import { ViewerDevice } from 'constants/enums';

export const imageSlug = {
  mobile: ViewerDevice.MOBILE,
  desktop: ViewerDevice.DESKTOP,
  tablet: ViewerDevice.TABLET,
};
